// TableV3 modelName prop: tsEntity.logicalId
export default {
  channel: 'Channel',
};
